import { Selector } from '@ngxs/store';
import { AuthState, AuthStateModel } from './auth.state';

export class AuthSelectors {
  @Selector([AuthState])
  static getLoadingStatus(state: AuthStateModel): boolean | null {
    return state.loading;
  }

  @Selector([AuthState])
  static getAuthToken(state: AuthStateModel): string | null {
    return state.token;
  }

  @Selector([AuthState])
  static getSessionStatus(state: AuthStateModel): boolean | null {
    return state.isSessionValid;
  }

  @Selector([AuthState])
  static getTokenExpiredUrl(state: AuthStateModel): string | null {
    return state.tokenExpiredUrl;
  }
 

  @Selector([AuthState])
  static getPermissions(state: AuthStateModel): { [key: string]: string }[] {
    return JSON.parse(localStorage.getItem('userPermissions') || '[]');
  }
  
  @Selector([AuthState])
  static getGlobalPermissions(state: AuthStateModel): { [key: string]: string }[] {
    return JSON.parse(localStorage.getItem('globalPermissions') || '[]');
  }
}
